import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { appAuthenticatedUserSelector } from '@core/application';
import { gettingAuthUserDataSelector } from '@geekbears/gb-ngrx-auth-basic';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { APP_ROUTES } from '@typings/app-routes.constant';
import { Roles } from '@utils/roles';
import { combineLatest, filter, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OnSingUpGuard implements CanActivate {
  constructor(
    private actions$: Actions,
    private router: Router,
    private store$: Store
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return combineLatest([
      this.store$.select(appAuthenticatedUserSelector),
      this.store$.select(gettingAuthUserDataSelector),
    ]).pipe(
      filter(([user, fetching]) => {
        return !fetching;
      }),
      map(([user, fetching]) => {
        if (!user) {
          this.router.navigateByUrl(
            APP_ROUTES.authentication['sign-in'].fullPath
          );
          return false;
        }

        if (user.isSubscriptionBypassed || user.company?.isSubscriptionBypassed) {
          this.router.navigateByUrl(APP_ROUTES.dashboard.fullPath);
          return false;
        }

        if (
          user &&
          user?._companyId !== null &&
          user?.accountConfirmedAt == null &&
          user?.requiresPasswordChange == false
        ) {
          if (this.isNotCompanyManager(user?.roles ?? [])) {
            if (!user?.company?._subscription) {
              if (user?.blocked == true) {
                this.router.navigateByUrl(APP_ROUTES.dashboard.fullPath);
                return false;
              } else return true;
            } else {
              this.router.navigateByUrl(APP_ROUTES.dashboard.fullPath);
            }
          } else {
            this.router.navigateByUrl(APP_ROUTES.dashboard.fullPath);
            return false;
          }
        }
        return true;
      })
    );
  }

  isNotCompanyManager(roles: string[]) {
    let temp = roles.filter((role: string) => {
      if (role == Roles.companyAdministrator) {
        return true;
      } else {
        return false;
      }
    });

    if (temp.length > 0) return true;
    else return false;
  }
}
